<template>
  <div class="topazio flex-column">
    <div class="background bg-1">
      <img :src="require(`@/assets/capas/a-topazio.webp`)">
    </div>
    <header>
      <div class="title title-1">A Topázio</div>
      <div class="text subtitle-6">
        Conheça mais sobre a Topázio
      </div>
    </header>
    <div class="content">
      <span class="title-1">A Topázio</span>
      <div class="subtitle-6">
        Começando a partir de um sonho, o Grupo Topázio fundou sua primeira indústria em 1996 com uma planta de 600m² e
        apenas 12 colaboradores, na cidade de Imperatriz-MA. Com o passar dos anos, o grupo vem expandindo, e hoje,
        conta com seis novas indústrias, que somam mais de 50.000m² de área construída e mais de 800 colaboradores
        diretos e 2.400 indiretos, tornando-se uma das maiores indústrias do Maranhão no seguimento mobiliário.
        <div class="spacing" />
        O Grupo Topázio está há quase três décadas produzindo colchões, estofados, móveis tubulares, dormitórios e
        cozinhas em MDF. Fabricando 70 mil peças por mês, o grupo distribui e comercializa seus produtos em doze estados da
        região norte, nordeste e centro – oeste do Brasil. Contamos com frota própria com mais de 100 caminhões, que
        levam nossos produtos nas mais diversas localidades do país.
      </div>
      <div class="post gradient" :style="scrollY < 185 ? 'opacity: 0' : ''">
        <div>
          <img src="@/assets/post.png">
        </div>
      </div>
      <div class="subtitle-6">
        Sempre pensando na preservação do nosso ecossistema, a Topazio trabalha com madeira de origem reflorestada e
        energia renovável, possuindo sua própria usina de energia fotovoltaica, hoje é reconhecida como a primeira
        indústria moveleira do maranhão a ser auto sustentável em energia limpa.
        <div class="spacing" />
        Procurando sempre investir na qualidade dos nossos produtos, estamos sempre capacitando nossa equipe de
        colaboradores para oferecer e produzir o que há de melhor.
        <div class="spacing" />
        <div class="body-1 text-center">
          INOVAÇÃO E DIVERSIFICAÇÃO SÃO MARCAS REGISTRADAS DA TOPÁZIO, TUDO ISSO PARA OFERECER AOS NOSSOS CLIENTES O
          QUE HÁ DE MELHOR.
        </div>
        <div class="spacing" />
        <div class="text-center">
          <i>
            TOPÁZIO <br>
            A MARCA DO CONFORTO E DA QUALIDADE 💚
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      scrollY: window.scrollY
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  }
}
</script>

<style lang="scss">
.topazio {
  justify-content: start;
  position: relative;
}
.topazio header{
  padding: 40px 80px;
  margin-top: 50px;
  margin-bottom: 13vw;
  text-align: left;
}
.topazio .background {
  position: absolute;
  overflow: hidden;
  top: -170px;
  left: -15vw;
  z-index: -1;
  width: 120vw;
  min-height: 430px;
  max-height: 430px;
  border-radius: 17%;
  transform: rotate(-3.5deg);
  box-shadow: 0px 3px 5px rgba(80, 80, 80, 0.52);
  img {
    width: 103%;
    margin-top: -90px;
  }
}
.topazio .content {
  padding: 0 10px;
  .post {
    transition: all 1s ease;
    width: 90vw;
    margin: 0 auto 0 auto;
    height: 65vw;
    max-width: 972px;
    max-height: 702px;
    div {
      width: 100%;
      height: 100%;
      max-width: 1263px;
      min-height: 130px;
      background: url("../assets/logos/logo-icon.png") no-repeat center;
      background-size: 20vw;
    }
    img {
      height: 100%;
    }
  }
}
.topazio .content .subtitle-6 {
  margin: 30px auto;
  max-width: 959px;
  text-align: start;
  .spacing {
    margin-top: 25px;
  }
}
.text-center {
  text-align: center !important;
}
i {
  font-weight: 500;
}
@media screen and (max-width: 1090px){
  .topazio .content .subtitle-6 {
    margin: 30px 50px !important;
  }
}
@media screen and (max-width: 930px) {
  .topazio .content .subtitle-6 {
    margin: 30px 40px !important;
  }
  .topazio .background {
    img {
      margin-top: 10px;
    }
  }
}
@media screen and (max-width: 730px) {
  .topazio .background {
    img {
      margin-top: 80px;
      width: 108%;
    }
  }
}
@media screen and (max-width: 575px) {
  .topazio header {
    margin-bottom: 20vw;
  }
  .topazio .content .subtitle-6 {
    margin: 30px 20px !important;
  }
  .topazio .background {
    img {
      width: 133%;
      min-width: 725px;
      margin-left: -30px;
      margin-top: 94px;
    }
  }
}
@media screen and (max-width: 425px){
  .topazio header{
    padding: 40px 40px;
  }
  .topazio .content .subtitle-6 {
    margin: 30px 10px !important;
  }
  #content {
    margin: 0 0;
  }
}
</style>